import type { ClipMediaSnapshot, ClipMediaUi } from "./clip-video-player-types";
import { HAVE_FUTURE_DATA, HAVE_METADATA } from "./clip-video-player-types";

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/**
 * Derives chrome flags from the element snapshot + scrub intent.
 * Center play never depends on `waiting` — that was the scrub-death bug.
 */
export function deriveClipMediaUi(
  snapshot: ClipMediaSnapshot,
  scrubbing: boolean,
  scrubTime: number | null,
): ClipMediaUi {
  const duration = Number.isFinite(snapshot.duration) ? snapshot.duration : 0;
  // Hold scrub intent after pointer-up until the element finishes seeking.
  const displayTime = scrubTime !== null ? scrubTime : snapshot.currentTime;

  // Center play when paused (including ended → replay). Never gate on waiting.
  const showCenterPlay =
    snapshot.paused && snapshot.readyState >= HAVE_METADATA;

  const showSpinner =
    !snapshot.paused &&
    !snapshot.ended &&
    !scrubbing &&
    (snapshot.waiting ||
      (snapshot.seeking && snapshot.readyState < HAVE_FUTURE_DATA));

  return {
    showSpinner,
    showCenterPlay,
    displayTime,
    progressRatio: duration > 0 ? clamp(displayTime / duration, 0, 1) : 0,
    bufferedRatio:
      duration > 0 ? clamp(snapshot.bufferedEnd / duration, 0, 1) : 0,
    effectiveVolume: snapshot.muted ? 0 : snapshot.volume,
  };
}

export function clampMediaTime(value: number, duration: number): number {
  const max = Number.isFinite(duration) && duration > 0 ? duration : value;
  return clamp(value, 0, max);
}
